import { render, staticRenderFns } from "./LostFound.vue?vue&type=template&id=558a1d12"
import script from "./LostFound.vue?vue&type=script&lang=js"
export * from "./LostFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports